<template>
  <div class="page page-bootcamp">

    <!-- Hero -->
    <div class="hero bootcamp-hero">

      <div class="hero-img">
        <parallax
          direction="down"
          breakpoint="(min-width: 50px)"
        >
          <picture>
            <source srcset="../assets/img/hero/bootcamp-hero.jpg" media="(min-width: 576px)">
            <img srcset="../assets/img/hero/bootcamp-hero-m.jpg" alt="">
          </picture>
        </parallax>
      </div>

      <div class="hero-content sr-only">
          <h1 class="page-title">Bootcamp</h1>
      </div>

    </div>

    <!-- Content -->
    <div class="bootcamp-content">

      <div class="container">

        <p class="mb-5">This class is for anyone looking to get fit &amp; have fun working out on the beautiful Playa del Rey Beach. The class is High Intensity Interval Training (HIIT) including battle ropes, kettlebells, barbells, sand bags, sprints and much more! All fitness levels welcome, you work at your own pace for 30 second intervals at each station.</p>

        <h2 class="text-center mb-5">Workout Stations</h2>

        <div class="fc-alternate">
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/demonstration.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>The<br/> Demonstration</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <a href="#" class="video-play" :click="prevent" v-b-modal.warmUpVideo>
                <img src="../assets/img/bootcamp/warm-up.jpg" alt="" />
              </a>
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>The<br/> Warm-Up</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/battle-ropes.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Battle Ropes</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/pad-work-1.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Pad Work</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/sledge-hammer.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Sledge Hammer</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/sand-bag-carry.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Sand Bag Carry</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/kettle-bell-1.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Kettle Bell Swing</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/jump-rope.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Jump Rope</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/core.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Core Strengthening</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/bands.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Band Work</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/medicine-ball.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Medicine Ball</h3>
              </div>
            </div>
          </div>
          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/bootcamp/sand-sprint.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Sand Sprint</h3>
              </div>
            </div>
          </div>
          <!-- <div class="fc-row">
            <div class="fc-img">
              <img src="https://picsum.photos/g/400/400" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>The Buyout</h3>
              </div>
            </div>
          </div> -->
          <div class="fc-row">
            <div class="fc-img">
              <img class="img-normal" src="../assets/img/bootcamp/team-work.jpg" alt="" />
              <img class="img-hover" src="../assets/img/bootcamp/team-work-2.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <h3>Team Work!</h3>
              </div>
            </div>
          </div>
        </div>

        <p class="lead text-center mb-5 mt-5">Come join the fun!</p>

      </div>

      <!-- Services -->
      <Services />

    </div>

    <!-- Modal Component -->
    <b-modal id="warmUpVideo" modal-class="bb-modal video-modal" centered size="lg" :hide-footer="true" @shown="focusClose" @hidden="stopVideo">
      <div class="embed-responsive embed-responsive-16by9">
        <youtube :video-id="videoId" :player-vars="playerVars" ref="youtube" class="embed-responsive-item"></youtube>

        <!-- <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/_ioZTIjWoD4?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> -->
      </div>
    </b-modal>

  </div>
</template>

<script>
import Parallax from '@/components/Parallax'
import Services from '@/components/Services'

export default {
  components: {
    Parallax,
    Services
  },

  data () {
    return {
      videoId: '_ioZTIjWoD4',
      playerVars: {
        autoplay: 0,
        rel: 0,
        showinfo: 0
      }
    }
  },

  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },

  methods: {
    focusClose (event) {
      this.$el.querySelector('#warmUpVideo button.close').focus()
    },

    prevent (event) {
      event.preventDefault()
      return event
    },

    stopVideo (event) {
      this.player.stopVideo()
    },

    playVideo (event) {
      this.player.playVideo()
    }
  },

  created () {
    this.$emit('ready')
  }

}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.bootcamp-hero {
  margin-bottom: 20px;
  @include media-breakpoint-up(md) {
    margin-bottom: 40px;
  }
}

.bootcamp-content {
  .fc-row {
    margin: rem(30) 0;
    padding: rem(30) 0;
    border-bottom: 1px solid $gray-200;

    .fc-content {
      h3 {
        margin: 0;
      }
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    @include media-breakpoint-up(sm) {
      border-bottom: 0;
      margin: 0;
      padding: 0;

      .fc-img {
        width: 50%;
      }

      .fc-content {
        width: 50%;
        padding: 0 rem(40);
        text-align: center;
      }
    }
  }
}
</style>
